import React, { useState, useRef } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { html } from "@codemirror/lang-html";
import { EditorView } from "@codemirror/view";
//themes
import { githubLight } from "@uiw/codemirror-theme-github";
import {
  ContextMenu,
  ContextMenuCheckboxItem,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuLabel,
  ContextMenuRadioGroup,
  ContextMenuRadioItem,
  ContextMenuSeparator,
  ContextMenuShortcut,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
  ContextMenuTrigger,
} from "@/components/ui/context-menu";
import { useListData } from "@utils/query/index.query";
import { endpoint } from "@services/api.services";
import { usePathname } from "@utils/hook/index.hook";
import { Input } from "@components/ui/input";
import { useDebounce } from "@pages/dashboard/test/hook";

type Props = {
  value: string;
  onChange: (e: string) => void;
  error?: string;
};

const MirrorEditor: React.FC<Props> = ({ value = "", onChange }) => {
  const [editorView, setEditorView] = useState<EditorView | null>(null);

  // Function to insert text at cursor position
  const insertTextAtCursor = (text: string) => {
    if (!editorView) return;

    const { state } = editorView;
    const { from, to } = state.selection.main;

    // Create a transaction to insert text
    const transaction = state.update({
      changes: { from, to, insert: text },
      selection: { anchor: from + text.length },
    });

    editorView.dispatch(transaction);
    editorView.focus();
  };

  // Handle context menu item clicks
  const handleContextMenuClick = (optionText: string) => {
    insertTextAtCursor(optionText);
  };
  const [searchText, setSearchText] = useState({
    stamps: "",
    signature: "",
  });
  const debouncedSignature = useDebounce({
    initalValue: searchText.signature,
    delay: 500,
  });
  const debouncedStamps = useDebounce({
    initalValue: searchText.stamps,
    delay: 500,
  });
  const { data: _rawData, isPending } = useListData({
    endpoint: endpoint["branding"],
    key: "branding-signature",
    params: {
      branding: "signatures",
      search: debouncedSignature,
    },
  });
  const data = _rawData as any;
  const { data: _rawDataStamps } = useListData({
    endpoint: endpoint["branding"],
    key: "branding-stamps",
    params: {
      branding: "stamps",
      search: debouncedStamps,
    },
  });
  const dataStamps = _rawDataStamps as any;
  const pathname = usePathname();

  return (
    <>
      <ContextMenu>
        <ContextMenuTrigger>
          <CodeMirror
            value={value}
            height="100%"
            width="100%"
            className="h-[500px]  overflow-auto  w-full"
            extensions={[html()]}
            onChange={(val) => {
              onChange(val);
            }}
            onCreateEditor={(view) => {
              setEditorView(view);
            }}
            basicSetup={{ autocompletion: true }}
            theme={githubLight}
          />
        </ContextMenuTrigger>
        <div className="">
          {pathname == "certificate-manage-template" && (
            <ContextMenuContent className="">
              <ContextMenuSub>
                <ContextMenuSubTrigger inset>
                  Student Details
                </ContextMenuSubTrigger>
                <ContextMenuSubContent className="w-44">
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{full_name}}")}
                  >
                    Full Name
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{email}}")}
                  >
                    Email
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{phone}}")}
                  >
                    Phone
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() =>
                      handleContextMenuClick("{{enrollment_date}}")
                    }
                  >
                    Enrollment Date
                  </ContextMenuItem>
                </ContextMenuSubContent>
              </ContextMenuSub>
              <ContextMenuSub>
                <ContextMenuSubTrigger inset>
                  Course Details
                </ContextMenuSubTrigger>
                <ContextMenuSubContent className="w-44">
                  <ContextMenuItem
                    onClick={() =>
                      handleContextMenuClick("{{completion_date}}")
                    }
                  >
                    Completion Date
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() =>
                      handleContextMenuClick("{{certificate_number}}")
                    }
                  >
                    Certificate Number
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{certificate_id}}")}
                  >
                    Certificate ID
                  </ContextMenuItem>

                  <ContextMenuItem
                    onClick={() =>
                      handleContextMenuClick("{{completion_date}}")
                    }
                  >
                    Completion Date
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{remarks}}")}
                  >
                    Remarks
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() =>
                      handleContextMenuClick("{{course_batch_name}}")
                    }
                  >
                    Course Batch Name
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() =>
                      handleContextMenuClick("{{course_batch_id}}")
                    }
                  >
                    Course Batch ID
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{course_name}}")}
                  >
                    Course Name
                  </ContextMenuItem>
                </ContextMenuSubContent>
              </ContextMenuSub>

              <ContextMenuSub>
                <ContextMenuSubTrigger inset>Signatures</ContextMenuSubTrigger>
                <ContextMenuSubContent className="w-44">
                  <Input
                    type="text"
                    placeholder="Search..."
                    onChange={(e) => {
                      setSearchText((prev) => ({
                        ...prev,
                        signature: e.target.value,
                      }));
                    }}
                  />
                  {data?.data?.results?.length > 0
                    ? data?.data?.results?.map((item: any) => (
                        <ContextMenuItem
                          onClick={() =>
                            handleContextMenuClick(
                              `<img src="${item?.image}" width="200px" height="200px" />`
                            )
                          }
                        >
                          {item.title}
                        </ContextMenuItem>
                      ))
                    : "No Signatures Available"}
                </ContextMenuSubContent>
              </ContextMenuSub>

              <ContextMenuSub>
                <ContextMenuSubTrigger inset>Stamps</ContextMenuSubTrigger>
                <ContextMenuSubContent className="w-44">
                  <>
                    <Input
                      type="text"
                      placeholder="Search..."
                      onChange={(e) => {
                        setSearchText((prev) => ({
                          ...prev,
                          stamps: e.target.value,
                        }));
                      }}
                    />
                    {dataStamps?.data?.results?.length > 0
                      ? dataStamps?.data?.results.map((item: any) => (
                          <ContextMenuItem
                            onClick={() =>
                              handleContextMenuClick(
                                `<img src="${item?.image}" width="200px" height="200px" />`
                              )
                            }
                          >
                            {item.title}
                          </ContextMenuItem>
                        ))
                      : "No Stamps Available"}
                  </>
                </ContextMenuSubContent>
              </ContextMenuSub>
            </ContextMenuContent>
          )}
        </div>

        <div className="">
          {pathname == "giveaway-templates" && (
            <ContextMenuContent className="">
              <ContextMenuSub>
                <ContextMenuSubTrigger inset>
                  Personal Info
                </ContextMenuSubTrigger>
                <ContextMenuSubContent className="w-44">
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{full_name}}")}
                  >
                    Full Name
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{email}}")}
                  >
                    Email
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{phone_number}}")}
                  >
                    Phone
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{address}}")}
                  >
                    Address
                  </ContextMenuItem>
                </ContextMenuSubContent>
              </ContextMenuSub>
              <ContextMenuSub>
                <ContextMenuSubTrigger inset>Learning</ContextMenuSubTrigger>
                <ContextMenuSubContent className="w-44">
                  <ContextMenuItem
                    onClick={() =>
                      handleContextMenuClick("{{education_level}}")
                    }
                  >
                    Education Level
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() =>
                      handleContextMenuClick("{{learning_format}}")
                    }
                  >
                    Learning Format
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{has_laptop}}")}
                  >
                    Has Laptop
                  </ContextMenuItem>
                </ContextMenuSubContent>
              </ContextMenuSub>

              <ContextMenuSub>
                <ContextMenuSubTrigger inset>Source</ContextMenuSubTrigger>
                <ContextMenuSubContent className="w-44">
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{referred_by}}")}
                  >
                    Referred By
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{source}}")}
                  >
                    Source
                  </ContextMenuItem>
                </ContextMenuSubContent>
              </ContextMenuSub>

              <ContextMenuSub>
                <ContextMenuSubTrigger inset>Course</ContextMenuSubTrigger>
                <ContextMenuSubContent className="w-44">
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{course}}")}
                  >
                    Course
                  </ContextMenuItem>
                  <ContextMenuItem
                    onClick={() => handleContextMenuClick("{{code}}")}
                  >
                    Unique Code
                  </ContextMenuItem>
                </ContextMenuSubContent>
              </ContextMenuSub>
            </ContextMenuContent>
          )}
        </div>
      </ContextMenu>
    </>
  );
};

export default MirrorEditor;
